import React from 'react';
import { Tooltip } from 'antd';
import { colors } from 'constants/common';

interface IProps {
  children: React.ReactNode;
  message: string;
}

const InfoTooltip: React.FC<IProps> = ({ children, message }) => {
  return (
    <Tooltip
      color={colors.pageBg}
      placement="bottomRight"
      zIndex={10002}
      title={message}
      styles={{
        body: {
          border: `1px solid ${colors.stroke}`,
          color: colors.purple50,
          maxWidth: '400px',
          padding: '16px',
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default InfoTooltip;
